import { render, staticRenderFns } from "./gui.vue?vue&type=template&id=28d988c2"
import script from "./gui.vue?vue&type=script&lang=js"
export * from "./gui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports